import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7.825 7.83l-5.568 9.295a1.914 1.914 0 0 0 1.636 2.871h16.107m1.998 -1.99a1.913 1.913 0 0 0 -.255 -.88l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0l-1.028 1.718","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconTriangleOff = createReactComponent('outline', 'triangle-off', 'TriangleOff', __iconNode);

export default IconTriangleOff;